'use strict';//Indicating browser should run only in java script mode

//*******PURPOSE: THIS SERVICE IS USEFUL IN COMMUNICATING WITH THE WCF METHODS OF STICKY NOTES
//*******EFFECTIVE FILES: ../Views/StickyNotes/..
//*******CREATED BY: 
//*******CREATED DATE: 
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

angular.module('EMR.Home').service('DocumentManagementCommonService', ['CommonService', 'CommonPostService',function (CommonService, CommonPostService) {

	//#################### METHOD TO GET INDEX DOCUMENTS FIELDS CUSTOMIZED LIST BLOCK START ######################
	//*******PURPOSE: THIS METHOD IS TO GET INDEX DOCUMENTS FIELDS CUSTOMIZED LIST
	//*******CREATED BY: MURALI M
	//*******CREATED DATE: 07/04/2018
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; ######################
	this.indexDocumentsFieldsGetCustomizedList = function (PostData) {

		PostData.practicemodel = EMRPracticeModel;
		PostData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

		return CommonService.PostData('POST', CommonService.EHR_IndexDocs_Customize_Fields_API() + "GetIndexDocsFieldsCustomizedList", PostData).then(
			function (result) {
				return result;
			});
	}
	//#################### METHOD TO GET INDEX DOCUMENTS FIELDS CUSTOMIZED LIST BLOCK END ######################

	//#################### METHOD FOR GETTING THE LIST OF DUPLICATE CHARTS LINKED TO CURRENT PATIENT BLOCK START ######################
	//*******PURPOSE: THIS IS USED FOR GETTING THE LIST OF DUPLICATE CHARTS LINKED TO CURRENT PATIENT
	//*******CREATED BY: MAHESH P
	//*******CREATED DATE: 12/08/2018
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.DocumentServiceGetEHRDocumentsRelatedSettings = function (PostData) {

		PostData.practicemodel = EMRPracticeModel;
		return CommonService.PostData('POST', CommonService.EHR_Documents_Settings_API() + "GetEHRDocumentsRelatedSettings", PostData).then(
			function (result) {
				return result;
			});
	};
	//#################### METHOD FOR GETTING THE LIST OF DUPLICATE CHARTS LINKED TO CURRENT PATIENT BLOCK END ######################	

    //#################### METHOD TO GET DOCUMENT MANAGEMENT SETTINGS BLOCK START ######################
    //*******PURPOSE: THIS METHOD TO GET DOCUMENT MANAGEMENT SETTINGS 
    //*******CREATED BY: ABDUL RAHIMAN M
    //*******CREATED DATE: 4/28/2017
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; ######################
    this.documentManagementServicGetDocumentManagementSettings = function (PostData) {

        PostData.practicemodel = EMRPracticeModel;
        PostData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

        return CommonService.PostData('POST', CommonService.EHR_Documents_Settings_API() + "GetDocumentManagementSettings", PostData).then(
            function (result) {
                return result;
            });
    };
    //#################### METHOD TO GET DOCUMENT MANAGEMENT SETTINGS BLOCK ENDS ######################

    //#############  METHOD TO DOCUMENTS CONCURANCY ACTIONS UPDATE BLOCK START  ##################
    //*******PURPOSE: THIS METHOD IS USED TO DOCUMENTS CONCURANCY ACTIONS UPDATE
    //*******CREATED BY         : AMARNATH
    //*******CREATED DATE       : 10/11/2019
    //*******MODIFIED DEVELOPER : DATE - NAME - WHAT IS MODIFIED; XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    this.DocumentServiceDocumentsConcurancyActionsUpdate = function (postData) {

        // ASSING THE PRACTICE MODEL TO THE POST DATA MODEL 
        // PRACTICE MODLE CONTAIN PRACTICE DETAILS DATA BASE LOGIN DETAILS .. ;LOGGED USER DETAILS // LOGIN USER DAETAILS
        postData.practicemodel = EMRPracticeModel;
        // CALLING THE POSTDATA METHOD IN COMMONSERVICE   TO CONNECT TTO THE API CALL //  HTTP POST REQUIEST
        // URL WILL BUILD IN THE CommonService.EMRPracticeManagement_DocumentMgmt()  AND APPENFDING THE  DocumentsConcurancyActionsUpdate AT END // FINAL URL OBTAINED
        // postData INPUT DATA TO THE APUICALL
        //result RESPONSE WILL ACHIVE THROUGH result PROPERTY
        //RETURN THE OBTAINED DATA 
        postData.WebSessionID = loginsessionIdforAPMReport;
        return CommonPostService.httpPostData('POST', CommonPostService.EHR_Documents_Concurrency_API() + "DocumentsConcurancyActionsUpdate", postData).then(
            function (result) {
                return result;
            });
    };
    //#############  METHOD TO DOCUMENTS CONCURANCY ACTIONS UPDATE BLOCK END  ##################

    //#############  METHOD TO VALIDATE SELECTED DOCUMENTS CONCURANCY ACTIONS BLOCK START  ##################
    //*******PURPOSE: THIS METHOD IS USED TO VALIDATE SELECTED DOCUMENTS CONCURANCY ACTIONS
    //*******CREATED BY         : AMARNATH
    //*******CREATED DATE       : 10/11/2019
    //*******MODIFIED DEVELOPER : DATE - NAME - WHAT IS MODIFIED; XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    this.DocumentServiceValidateSelectedDocumentsConcurancyActions = function (postData) {

        // ASSING THE PRACTICE MODEL TO THE POST DATA MODEL 
        // PRACTICE MODLE CONTAIN PRACTICE DETAILS DATA BASE LOGIN DETAILS .. ;LOGGED USER DETAILS // LOGIN USER DAETAILS
        postData.practicemodel = EMRPracticeModel;
        // CALLING THE POSTDATA METHOD IN COMMONSERVICE   TO CONNECT TTO THE API CALL //  HTTP POST REQUIEST
        // URL WILL BUILD IN THE CommonService.EMRPracticeManagement_DocumentMgmt()  AND APPENFDING THE  ValidateSelectedDocumentsConcurancyActions AT END // FINAL URL OBTAINED
        // postData INPUT DATA TO THE APUICALL
        //result RESPONSE WILL ACHIVE THROUGH result PROPERTY
        //RETURN THE OBTAINED DATA 
        return CommonPostService.httpPostData('POST', CommonPostService.EHR_Documents_Concurrency_API() + "ValidateSelectedDocumentsConcurancyActions", postData).then(
            function (result) {
                return result;
            });
    };
    //#############  METHOD TO DOCUMENTS CONCURANCY ACTIONS INSERT BLOCK END  ##################

    //#############  METHOD TO DOCUMENTS CONCURANCY ACTIONS INSERT BLOCK START  ##################
    //*******PURPOSE: THIS METHOD IS USED TO DOCUMENTS CONCURANCY ACTIONS INSERT
    //*******CREATED BY         : AMARNATH
    //*******CREATED DATE       : 10/11/2019
    //*******MODIFIED DEVELOPER : DATE - NAME - WHAT IS MODIFIED; XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    this.DocumentServiceDocumentsConcurancyActionsInsert = function (postData) {

        // ASSING THE PRACTICE MODEL TO THE POST DATA MODEL 
        // PRACTICE MODLE CONTAIN PRACTICE DETAILS DATA BASE LOGIN DETAILS .. ;LOGGED USER DETAILS // LOGIN USER DAETAILS
        postData.practicemodel = EMRPracticeModel;
        // CALLING THE POSTDATA METHOD IN COMMONSERVICE   TO CONNECT TTO THE API CALL //  HTTP POST REQUIEST
        // URL WILL BUILD IN THE CommonService.EMRPracticeManagement_DocumentMgmt()  AND APPENFDING THE  DocumentsConcurancyActionsInsert AT END // FINAL URL OBTAINED
        // postData INPUT DATA TO THE APUICALL
        //result RESPONSE WILL ACHIVE THROUGH result PROPERTY
        //RETURN THE OBTAINED DATA 
        postData.WebSessionID = loginsessionIdforAPMReport;
        return CommonPostService.httpPostData('POST', CommonPostService.EHR_Documents_Concurrency_API() + "DocumentsConcurancyActionsInsert", postData).then(
            function (result) {
                return result;
            });
    };
    //#############  METHOD TO DOCUMENTS CONCURANCY ACTIONS INSERT BLOCK END  ##################


}]);